import { StyleSheet } from "@react-pdf/renderer";

/**
 * Base styles for ATS PDF templates (@react-pdf/renderer).
 * @see https://react-pdf.org/styling
 */
export const atsPdfStyles = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    fontSize: 10,
    paddingTop: 40,
    paddingBottom: 48,
    paddingHorizontal: 40,
    color: "#1a1a1a",
    lineHeight: 1.45,
  },
  headerName: {
    fontSize: 20,
    fontFamily: "Helvetica-Bold",
    marginBottom: 4,
  },
  headerSubtitle: {
    fontSize: 11,
    color: "#555555",
    marginBottom: 8,
  },
  contactRow: {
    fontSize: 9,
    color: "#555555",
    marginBottom: 2,
  },
  headerRule: {
    borderBottomWidth: 1,
    borderBottomColor: "#cccccc",
    marginTop: 10,
    marginBottom: 14,
  },
  sectionTitle: {
    fontSize: 10,
    fontFamily: "Helvetica-Bold",
    textTransform: "uppercase",
    letterSpacing: 0.6,
    marginBottom: 6,
    marginTop: 4,
    color: "#111111",
  },
  sectionRule: {
    width: "100%",
    height: 1,
    backgroundColor: "#dddddd",
    marginBottom: 10,
  },
  rowBetween: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 6,
  },
  expTitle: {
    fontFamily: "Helvetica-Bold",
    fontSize: 10,
  },
  expCompany: {
    fontSize: 9,
    color: "#555555",
    marginTop: 2,
  },
  expDates: {
    fontSize: 9,
    color: "#555555",
    textAlign: "right",
    maxWidth: "35%",
  },
  bullet: {
    fontSize: 9,
    color: "#444444",
    marginLeft: 10,
    marginBottom: 3,
  },
  muted: {
    color: "#555555",
    fontSize: 9,
  },
  skillsRow: {
    flexDirection: "row",
    borderBottomWidth: 0.5,
    borderBottomColor: "#eeeeee",
    paddingVertical: 4,
  },
  skillsCol: {
    width: "78%",
    paddingRight: 8,
  },
  skillsLevel: {
    width: "22%",
  },
  footer: {
    position: "absolute",
    bottom: 24,
    right: 40,
    fontSize: 8,
    color: "#888888",
  },
});
